import React from 'react';

export const AutoDetectLocationErrorCmp: React.FC<{ message: string }> = ({
  message,
}) => (
  <div
    data-testid="location-error-msg"
    id="location-error-msg"
    className="text-red-500 text-sm mt-2 text-center"
  >
    {message}
  </div>
);
